// extracted by mini-css-extract-plugin
module.exports = {"error":"#ff4040","success":"#28cb93","primary-color":"#00bfb2","dark-grey-color":"#444","container":"AddButton_container__3l8r7","icon":"AddButton_icon__hsC0L"};